import React from 'react';
import { cn } from '@/utils/cn';
import TextSmall from '../Typography/TextSmall';

function DiscountOfferBadge({
  offerText = '20%',
  className,
  textClassName = '',
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-center bg-richcarmine w-max px-6 lg:px-8 py-4 lg:py-6 rounded-tl-[10px] lg:rounded-tl-xl rounded-br-[10px] lg:rounded-br-xl lg:h-[28px]',
        className,
      )}
    >
      <TextSmall
        text={offerText}
        className={cn(
          'text-xss lg:text-sm text-white font-bold tracking-[0.20px] lg:tracking-[0.24px]',
          textClassName,
        )}
      />
    </div>
  );
}

export default DiscountOfferBadge;
